export let version = '0.0.111'; // generated source, do not edit
